import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
// import { CheckCircle } from "lucide-react";
import img from "../../assets/Medallion – Burst Animation.gif"

const CongratsModal = ({ show = false, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <AnimatePresence>
        {show &&
         <motion.div
         initial={{ opacity: 0 }}
         animate={{ opacity: 1}}
         exit={{ opacity: 0 }}
         transition={{ duration: 0.5 }}
         className="fixed z-[9999] inset-0 flex items-center justify-center bg-gray-900/20 backdrop-filter backdrop-blur-sm"
       >
         <motion.div
         initial={{ opacity: 0, scale: 0.8 }}
         animate={{ opacity: 1,  scale: 1 }}
         exit={{ opacity: 0,  scale: 0.8 }}
         transition={{ duration: 0.5 }} 
         className="  bg-white p-6 rounded-2xl shadow-lg text-center w-80 relative">
           <div className="flex justify-center">
             <div className="relative">
               {/* <div className="w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center shadow-md"> */}
                 {/* <CheckCircle className="w-12 h-12 text-white" /> */}
                 <img src={img} className={"rounded-lg"}/>
               {/* </div> */}
               {/* <div className="absolute inset-0 animate-ping bg-yellow-400 opacity-50 rounded-full"></div> */}
             </div>
           </div>
           <h2 className="text-xl font-bold mt-4 text-gray-800 text-center">Félicitation</h2>
           <p className="text-gray-600 mt-2 text-sm text-center">Vous avez fait du bon boulot !</p>
           <button
             onClick={onClose}
             className="mt-4 bg-primary-green text-emerald-700 px-5 py-2 rounded-full shadow-md hover:bg-primary-green/90 transition"
           >
             Continuer
           </button>
         </motion.div>
       </motion.div>
        }
     
    </AnimatePresence>
  );
};

export default CongratsModal